const LoadingsTestIds = {
  LOADING_PROGRESS: 'loading-progress',
  LOADING_PROGRESS_VIDEO: 'loading_progress_video',
};

export {
  LoadingsTestIds,
};
